import { Component, StrictMode, type ErrorInfo, type ReactNode } from "react"
import { createRoot } from "react-dom/client"
import { RouterProvider } from "react-router-dom"
import sutuconDesignSystem from "./sutucon-ds.css?inline"
import simbaStyles from "./tailwind.css?inline"
import { TooltipProvider } from "@/components/ui/tooltip"
import { Button } from "@/components/ui/button"
import { SessionProvider } from "@/app/session"
import { router } from "@/app/router"

// Mỗi trang là một màn hình mới, không tiếp nối vị trí cuộn của trang trước.
if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual"
router.subscribe(() => {
  if (!location.hash) window.scrollTo({ top: 0, left: 0, behavior: "auto" })
})

// CSS đi kèm trong JS: tránh trang mới tham chiếu file CSS của bản deploy khác.
const styleElement = document.createElement("style")
styleElement.dataset.simbaStyles = ""
styleElement.textContent = sutuconDesignSystem + simbaStyles
document.head.appendChild(styleElement)

class SimbaErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() {
    return { failed: true }
  }
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Simba render failed", error, info)
  }
  render() {
    if (!this.state.failed) return this.props.children
    return (
      <div className="grid min-h-svh place-items-center bg-sand p-6 text-center">
        <div className="flex max-w-md flex-col items-center gap-4">
          <img src="/brand/sutucon/mascots-2d/elephant-thinking.svg" alt="" className="size-28" />
          <h1 className="text-2xl font-bold">Trang này chưa hiện được</h1>
          <p className="text-muted-foreground">Có lỗi khi vẽ trang. Con tải lại trang để thử lại nhé.</p>
          <Button onClick={() => location.reload()}>Tải lại</Button>
        </div>
      </div>
    )
  }
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SimbaErrorBoundary>
      <TooltipProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </TooltipProvider>
    </SimbaErrorBoundary>
  </StrictMode>,
)
